import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = async (email, password) => {
    try {
      const response = await authAPI.login(email, password);
      
      const { token, user } = response.data.data || response.data;
      
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      setCurrentUser(user);
      
      return response;
    } catch (error) {
      const errorMessage = error.message || 'Login failed. Please try again.';
      
      if (errorMessage.includes('Invalid') || errorMessage.includes('credentials') || errorMessage.includes('401')) {
        throw new Error('Invalid email or password. Please check your credentials.');
      } else if (errorMessage.includes('Network') || errorMessage.includes('fetch') || errorMessage.includes('Connection')) {
        throw new Error('Connection error. Please check your internet connection.');
      } else {
        throw new Error('Login failed. Please check your credentials and try again.');
      }
    }
  };

  const logout = async () => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      setCurrentUser(null);
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        
        if (token && user) {
          const response = await authAPI.getCurrentUser();
          setCurrentUser(response.data.data || response.data);
        } else {
          setCurrentUser(null);
        }
      } catch (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setCurrentUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  const value = {
    currentUser,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
